/* global axios */
import ApiClient from './ApiClient';

// NB: do NOT name the per-bot URL helper `baseUrl` — ApiClient's `get url()`
// getter calls `this.baseUrl()`, so overriding it here recurses infinitely.
class KnowledgeEnrichmentGapSuggestionsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  scopedUrl(agentBotId) {
    return `${this.url}/${agentBotId}/knowledge_enrichment/gap_suggestions`;
  }

  index(agentBotId, { page = 1, status = 'open', language } = {}) {
    return axios.get(this.scopedUrl(agentBotId), {
      params: { page, status, language },
    });
  }

  show(agentBotId, id) {
    return axios.get(`${this.scopedUrl(agentBotId)}/${id}`);
  }

  answer(agentBotId, id, { question, answer }) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/answer`, {
      gap_suggestion: { question, answer },
    });
  }

  dismiss(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/dismiss`);
  }

  delete(agentBotId, id) {
    return axios.delete(`${this.scopedUrl(agentBotId)}/${id}`);
  }
}

export default new KnowledgeEnrichmentGapSuggestionsAPI();
